module.exports = __webpack_public_path__ + "img/jiashan.438d938e.jpg";